import React from "react";
import { CheckBoxComp } from "../../../inputs/fields.component";
import { useTranslation } from "react-i18next";

const MetricProgressConsider = props => {
  const { considerProgress, setConsiderProgress } = props;
  const { t, i18n } = useTranslation();

  return (
    <div className="metric-submenu-section">
      <div className="breakline" />
      <div className="fieldcontent jiraExclude">
        <CheckBoxComp
          label={t(`Exclude from objective progress calculation`)}
          id="jiraExcludeObj"
          subclassDefined = "displayInLineBlk"
          onChange={setConsiderProgress}
          checkboxProps={{ defaultChecked: considerProgress }}
        />
      </div>
    </div>
  );
};

export default MetricProgressConsider;
